import config from '@/common/config'
import { createFeatureDecisions } from '@/services/features/featureDecisions'

const getDefaultState = () => {
  return {
    flags: config.get('app.featureFlags'),
    loadingCount: 0,
    crudLoadingCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'features',
    featureFlags: (state) => createFeatureDecisions(state.flags),
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
    SET_FEATURE_FLAGS(state, flags) {
      state.flags = flags
    },
  },
  actions: {
    setFeatureFlags({ commit }, flags) {
      commit('SET_FEATURE_FLAGS', flags)
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
